import type { Command } from './types';
import { getLayoutEngine } from '@/layout/layoutEngine';
import { measureTextSize } from '@/layout/measure';

export const viewCommands: Command[] = [
  {
    id: 'view.zoomIn',
    label: 'Zoom In',
    category: 'view',
    execute: (ctx) => {
      ctx.editorState.adjustZoom(0.1);
    },
  },
  {
    id: 'view.zoomOut',
    label: 'Zoom Out',
    category: 'view',
    execute: (ctx) => {
      ctx.editorState.adjustZoom(-0.1);
    },
  },
  {
    id: 'view.fitToScreen',
    label: 'Fit to Screen',
    category: 'view',
    execute: (ctx) => {
      const svgEl = document.querySelector('svg');
      if (!svgEl) return;

      const nodes = ctx.doc.getAllNodes();
      const meta = ctx.doc.getMeta();
      const settings = ctx.doc.getSettings();

      if (!meta.rootNodeId || nodes.size === 0) return;

      // Compute layout to get total bounds
      const layout = getLayoutEngine(settings.layoutType).compute({
        nodes,
        rootNodeId: meta.rootNodeId,
        settings: {
          horizontalGap: settings.horizontalGap,
          verticalGap: settings.verticalGap,
          nodePaddingX: 16,
          nodePaddingY: 10,
        },
        measureText: measureTextSize,
      });

      const { totalBounds } = layout;
      if (totalBounds.width === 0 || totalBounds.height === 0) return;

      // Get viewport dimensions
      const rect = svgEl.getBoundingClientRect();
      const padding = 60;
      const viewportW = rect.width - padding * 2;
      const viewportH = rect.height - padding * 2;

      if (viewportW <= 0 || viewportH <= 0) return;

      // Calculate zoom to fit
      const zoomX = viewportW / totalBounds.width;
      const zoomY = viewportH / totalBounds.height;
      const zoom = Math.min(zoomX, zoomY, 2); // Cap at 2x

      // Calculate pan to center the map in the viewport
      // The map center in layout space:
      const mapCenterX = totalBounds.x + totalBounds.width / 2;
      const mapCenterY = totalBounds.y + totalBounds.height / 2;

      // Pan so that mapCenter * zoom is at viewport center
      const panX = rect.width / 2 - mapCenterX * zoom;
      const panY = rect.height / 2 - mapCenterY * zoom;

      ctx.editorState.setZoom(zoom);
      ctx.editorState.setPan(panX, panY);
    },
  },
  {
    id: 'view.toggleToolbar',
    label: 'Toggle Toolbar',
    category: 'view',
    execute: (ctx) => {
      ctx.editorState.toggleToolbar();
    },
  },
];
